export enum FeedbackMigrateCodes {
    Orders = 'orders',
    Products = 'products',
    Others = 'others',
}

export interface FeedbackSubjectListItem {
    id: number;
    title: string;
    code: FeedbackMigrateCodes | string;
    sort: number;
    active: boolean;
}
